// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import contractEntity from './entities/contract.json';
import contractMenu from '../pages/contract/menu.json';
import contractFullForm from '../pages/contract/forms/full.json';
import contractContextForm from '../pages/contract/forms/context.json';
import contractMiniForm from '../pages/contract/forms/mini.json';
import contractLookupForm from '../pages/contract/forms/lookup.json';
import contractTableView from '../pages/contract/views/table.json';
import contractStagesView from '../pages/contract/views/stages.json';
import contractCardsView from '../pages/contract/views/cards.json';
import contractSplitView from '../pages/contract/views/split.json';
import contractCalendarView from '../pages/contract/views/calendar.json';
import contractDashboardView from '../pages/contract/views/dashboard.json';

/** Тип запису «Договір» зі сторінками пакета: меню, форми та подання з pages/contract/. */
export const contractDefinition: IRecordTypeDefinition = {
  ...contractEntity,
  views: assembleViewSet({
      table: contractTableView,
      stages: contractStagesView,
      cards: contractCardsView,
      split: contractSplitView,
      calendar: contractCalendarView,
      dashboard: contractDashboardView,
  }),
  form: contractFullForm,
  forms: { full: contractFullForm, context: contractContextForm, mini: contractMiniForm, lookup: contractLookupForm },
  menu: contractMenu,
} as IRecordTypeDefinition;
